export default __webpack_public_path__ + "static/media/futura-preview-2.10234f60.png";